<div class="c-page-newcardform">
    <div class="container u-pb60">
        <div class="row mobile--orange u-pt30">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a [routerLink]="['/']">{{'NewCardPortal.home'|translate}}</a></li>
                        <li class="breadcrumb-item active" aria-current="page">&nbsp;-&nbsp; </li><span
                            class="">{{'NewCardPortal.location' | translate}}</span>
                    </ol>
                </nav>

                <h2 class="o-title">{{ 'NewCardPortal.titleCard' | translate}}
                </h2>
                <p class="o-text">{{ 'NewCardPortal.subtitleCard' | translate}}.</p>
            </div>
        </div>

        <ngx-spinner name="uploading" bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-grid-beat">
            <p style="font-size: 20px; color: white">{{'NewCardPortal.spinner'|translate}}...</p>
        </ngx-spinner>


        <form class="o-form" [formGroup]="formNewcard">
            <div class="row u-pt20">
                <div class="col-md-6">
                    <div id="siteSelect" class="form-group u-pb20">
                        <label
                            class="o-title o-title--label o-title--required">{{ 'NewCardPortal.labelSite' | translate}}</label>



                        <select name="siteSelect" (change)="changeSelect($event.target.value)" formControlName="siteId"
                            class="o-form__select" required>
                            <option [value]="''" disabled>{{ 'NewCardPortal.selOption' | translate}}</option>
                            <option [value]="opsite.site_id" *ngFor="let opsite of site">{{opsite.site_name}}</option>
                        </select>

                        <div *ngIf="formNewcard.controls['siteId'].hasError('required') && submited"
                            style="width:100%; background-color: #F2F0E9" align="center">
                            <span>
                                <h5 style="padding: 15px;">
                                    <mat-error style=" white-space: normal; "><i class="icon icon-close"></i>
                                        {{ 'NewCardPortal.selOption' | translate}}</mat-error>
                                </h5>
                            </span>
                        </div>
                        <div class="row  u-pb20 u-mb20">
                            <div class="col-md-12 elementDiv"   *ngIf="!buttonEnable">
                                <span class="elementSpan">{{ 'EmployeeAccessPortal.msgCas' | translate}}<i class="icon icon-close"></i></span>
                            </div>
                          
                        </div>

                    </div>
                </div>
                <div class="col-md-6">
                    <div id="pickSelect" class="form-group u-pb20">
                        <label
                            class="o-title o-title--label o-title--required">{{ 'NewCardPortal.labelPickup' | translate}}</label>
                        <select name="pickupSelect" formControlName="pickupId" class="o-form__select" required
                            [attr.disabled]="formNewcard.controls['siteId'].hasError('required') ? true : null"
                            bind-style.background-color="formNewcard.controls['siteId'].hasError('required') ? '#F2F0E9' : ''"
                            bind-style.cursor="formNewcard.controls['siteId'].hasError('required') ? 'no-drop' : ''">
                            <option [value]="''" disabled>{{ 'NewCardPortal.selOption' | translate}}</option>
                            <option [value]="pickup.pickupId" *ngFor="let pickup of selectpickups">
                                <p *ngIf="getlang()==='en'"> {{pickup.pickupName}}</p>
                                <p *ngIf="getlang()==='es'"> {{pickup.pickupNameEs}}</p>
                            </option>
                        </select>
                        <div *ngIf="formNewcard.controls['pickupId'].hasError('required') && submited"
                            style="width:100%; background-color: #F2F0E9" align="center">
                            <span>
                                <h5 style="padding: 15px;">
                                    <mat-error style=" white-space: normal; "><i class="icon icon-close"></i>
                                        {{ 'NewCardPortal.selOption' | translate}}</mat-error>
                                </h5>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="hr orange u-mt40"></div>
            <div class="row u-pt20">
                <div class="col-md-12">
                    <h2 class="o-title o-title--medium o-title--orange u-mb30 ">
                        {{ 'NewCardPortal.titleInformation' | translate}}</h2>
                    <label
                        class="o-title o-title--small o-title--semi u-mb10 ">{{ 'NewCardPortal.subtitleDataEntry' | translate}}</label>
                    <label
                        class="o-text o-text--description ">{{ 'NewCardPortal.workerIdentify' | translate}}</label>
                </div>
                <div class="col-md-12">


                    <div *ngIf="formRadio.controls['options'].hasError('required') && submited"
                        style="width:100%; background-color: #F2F0E9" align="center">
                        <span>
                            <h5 style="padding: 15px;">
                                <mat-error style=" white-space: normal; "><i class="icon icon-close"></i>
                                    {{ 'NewCardPortal.selOption' | translate}}</mat-error>
                            </h5>
                        </span>
                    </div>
                    <br>
                    <form class="o-form" [formGroup]="formRadio">
                        <div class="o-form__tabSH u-mb30" id="radioManualBulk">


                            <input class="form-check-input" type="radio" formControlName="options" value="manual"
                                id="manual" (change)="cleanManual()">
                            <label class="transition equalHM"
                                for="manual"><strong>{{ 'NewCardPortal.manualUpload' | translate}}</strong>
                                <p>{{ 'NewCardPortal.manualDescription' | translate}}</p>
                            </label>
                            <input class="form-check-input" type="radio" formControlName="options" value="bulk"
                                id="bulk" value="bulk" (change)="cleanBulk()">
                            <label class="transition equalHM"
                                for="bulk"><strong>{{ 'NewCardPortal.bulkUpload' | translate}}</strong>
                                <p>{{ 'NewCardPortal.bulkDescription' | translate}}</p>
                            </label>



                        </div>
                    </form>
                </div>
                <div class="o-form__tabresponse" id="responsemanual" *ngIf="formRadio.value.options==='manual'"
                    style="display: block;">
                    <div class="col-md-12 u-pt30">
                        <h2 class="o-title o-title--small o-title--semi u-mb10 ">{{'NewCardPortal.dataEntry' | translate}}
                        </h2>
                        <p class="o-text u-pb30 "> {{'NewCardPortal.dataEntryInfo' | translate}}</p>
                        <div *ngIf="formTableEntry.length===0 && submited" style="width:100%; background-color: #F2F0E9"
                            align="center">
                            <span>
                                <h5 style="padding: 15px;">
                                    <mat-error style=" white-space: normal; "><i class="icon icon-close"></i>
                                        {{'NewCardPortal.leastWarn' | translate}} </mat-error>
                                </h5>
                            </span>
                        </div>
                        <div class="row">
                            <div class="col-md-12 u-pt30 ">
                                <div class="o-etable">
                                    <div class="o-etable__employee">
                                        <div class="row">
                                            <div class="col-md-1 col-xs-2 ">
                                                <p> <strong>{{'NewCardPortal.colNumber' | translate}}</strong></p>
                                            </div>
                                            <div class="col-md-1 col-xs-2  ">
                                                <p class="u-hide__desktop">
                                                    <strong>{{'NewCardPortal.colType' | translate}}</strong></p>
                                            </div>
                                            <div class="col-md-2 col-xs-10  col-md-offset-0 col-xs-offset-0">
                                                <p class="u-show__mobile">
                                                    <strong>{{'NewCardPortal.colDetails' | translate}} </strong></p>
                                                <p class="u-hide__desktop">
                                                    <strong>{{'NewCardPortal.colRutpass' | translate}}</strong></p>
                                            </div>
                                            <div class="col-md-2 col-xs-10 col-md-offset-0 col-xs-offset-2">
                                                <p class="u-hide__desktop">
                                                    <strong>{{'NewCardPortal.colName' | translate}}</strong></p>
                                            </div>
                                            <div class="col-md-3 col-xs-10 col-md-offset-0 col-xs-offset-2">
                                                <p class="u-hide__desktop">
                                                    <strong>{{'NewCardPortal.colEmail' | translate}}</strong></p>
                                            </div>
                                            <div class="col-md-2 col-xs-10 col-md-offset-0 col-xs-offset-2">
                                                <div class=" u-hide__desktop">
                                                    <p><strong> {{'NewCardPortal.colPhoto' | translate}}</strong>&nbsp;
                                                        <!-- <span class="ptooltip--static ptooltip" matTooltip="{{'NewCardPortal.photoTooltip' | translate}} "> ? </span> -->
                                                        <svg matTooltip="{{'NewCardPortal.photoTooltip' | translate}}"
                                                            width="1em" height="1em" viewBox="0 0 16 16"
                                                            class="bi bi-question-circle ptooltip--static ptooltip"
                                                            fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                            <path fill-rule="evenodd"
                                                                d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                                            <path
                                                                d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z" />
                                                        </svg>&nbsp;<label style="color: coral;">*</label>
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="col-md-1 col-xs-10 col-md-offset-0 col-xs-offset-2">
                                                <p class="u-hide__desktop"> <strong>
                                                        {{'NewCardPortal.colAction' | translate}} </strong></p>
                                            </div>
                                        </div>
                                    </div>
                                    <div *ngIf="formTableEntry.length===0" class="o-etable__employee ">
                                        <div class="row">
                                            <div class="col-md-6 col-md-offset-1">
                                                <p>{{'NewCardPortal.warnDataEntry' | translate}}</p>
                                            </div>
                                        </div>

                                    </div>

                                    <div class="o-etable--body parent_etable" *ngIf="formTableEntry.length!=0">
                                        <br>
                                        <div *ngFor="let item of formTableEntry; let i = index"
                                        class="o-etable__employee o-etable__employee--approved">
                                        <a class="remove-employee" (click)="deletePeople(i)"></a>

                                            <div class="row">

                                                <div class="col-md-1 col-xs-2" align="center">
                                                    <p><span
                                                            bind-style.color="item.request_access_card === true ? 'green' : 'red'"><b>{{i+1}}
                                                            </b></span></p>
                                                </div>
                                                <div align="center"
                                                    class="col-md-1 col-xs-2 col-md-offset-0 col-xs-offset-0">
                                                    <p>
                                                        <span
                                                            bind-style.color="item.request_access_card === true ? 'green' : 'red'"
                                                            *ngIf="item.passportNumber">{{'NewCardPortal.labelPassport' | translate}}</span>
                                                        <span
                                                            bind-style.color="item.request_access_card === true ? 'green' : 'red'"
                                                            *ngIf="item.passportNumber && item.nationalId"> / </span>
                                                        <span style="margin-right: 250px;"
                                                            bind-style.color="item.request_access_card === true ? 'green' : 'red'"
                                                            *ngIf="item.nationalId">{{'NewCardPortal.labelRUT' | translate}}</span>
                                                    </p>
                                                </div>
                                                <div class="col-md-2 col-xs-10 col-md-offset-0 col-xs-offset-2">
                                                    <p><span
                                                            *ngIf="item.passportNumber">{{item.passportNumber}}</span><span
                                                            *ngIf="item.passportNumber && item.nationalId"> / </span>
                                                        <span *ngIf="item.nationalId">{{item.nationalId}}</span></p>
                                                </div>
                                                <div class="col-md-2 col-xs-10 col-md-offset-0 col-xs-offset-2">
                                                    <p style=" white-space: normal;">{{item.full_name}}</p>
                                                </div>
                                                <div class="col-md-3 col-xs-10 col-md-offset-0 col-xs-offset-2"
                                                    style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
                                                    title="{{item.email}}">
                                                    {{item.email}}
                                                </div>
                                                <div *ngIf="item.request_access_card===true"
                                                    class="col-md-2 col-xs-10 col-md-offset-0 col-xs-offset-2">
                                                    <div class="custom-file custom-file--small">
                                                        <div style="margin-right: 50px;" class="custom-file-text" *ngIf="!item.image_name"
                                                            type="file">
                                                            <div class="custom-file-text-cont"><i
                                                                    class="icon icon-clip"></i>
                                                                <p>{{'NewCardPortal.labelAttach' | translate}} </p>
                                                            </div>
                                                        </div>
                                                        <div class="custom-file-text" *ngIf="item.image_name"
                                                            type="file">
                                                            <div class="custom-file-text-cont"><i
                                                                    class="icon icon-check"></i>
                                                                <p>{{item.image_name}} </p>
                                                            </div>
                                                        </div>
                                                        <div class="custom-file-input">
                                                            <!-- <input class="custom-file-input attach_photo" type="file" accept=".jpg" (click)="fileInput= null" (change)="changeListener($event, i)"
                                                            [attr.title]="item.image ? item.image_name: 'upload Img'"
                                                            > -->
                                                            <input class="custom-file-input attach_photo" type="file"
                                                                accept=".jpg" (click)="null"
                                                                (change)="changeListener($event, i)"
                                                                [attr.title]="item.image_name">
                                                            <span *ngIf="item.image_name">{{'NewCardPortal.uploadAgain' | translate}}</span>
                                                            <span *ngIf="!item.image_name">{{'NewCardPortal.uploadFile' | translate}}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div *ngIf="item.request_access_card===false"
                                                    class="col-md-2 col-xs-10 col-md-offset-0 col-xs-offset-2">
                                                    <div class="custom-file custom-file--small">
                                                        -
                                                    </div>
                                                </div>
                                                <!-- <div align="center"
                                                    class="col-md-1 col-xs-12 col-md-offset-0 col-xs-offset-0">
                                                    <button (click)="deletePeople(i)"
                                                        style="border: 0; background-color: transparent;">
                                                        <svg class="bi bi-x" width="2em" height="2em"
                                                            viewBox="0 0 20 20" fill="currentColor"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <path fill-rule="evenodd"
                                                                d="M5.646 5.646a.5.5 0 000 .708l8 8a.5.5 0 00.708-.708l-8-8a.5.5 0 00-.708 0z"
                                                                clip-rule="evenodd"></path>
                                                            <path fill-rule="evenodd"
                                                                d="M14.354 5.646a.5.5 0 010 .708l-8 8a.5.5 0 01-.708-.708l8-8a.5.5 0 01.708 0z"
                                                                clip-rule="evenodd"></path>
                                                        </svg>
                                                    </button>
                                                </div> -->
                                                <div style="width:100% " *ngIf="item.sizeImageError===true"
                                                    class="col-md-12 col-xs-12 col-md-offset-0 col-xs-offset-2">
                                                    <h6 style="color: red;"><i class="icon icon-close"></i><a
                                                            style=" white-space: normal;">{{'NewCardPortal.warnImageSize' | translate}}</a>
                                                    </h6>
                                                </div>
                                                <div style="width:100% " *ngIf="item.controlNameImageError===true"
                                                    class="col-md-12 col-xs-12 col-md-offset-0 col-xs-offset-2">
                                                    <h6 style="color: red;"><i class="icon icon-close"></i><a
                                                            style=" white-space: normal;">{{'NewCardPortal.warnImageNumber' | translate}}</a>
                                                    </h6>
                                                </div>
                                                <div style="width:100% " *ngIf="item.formatImageError===true"
                                                    class="col-md-12 col-xs-12 col-md-offset-0 col-xs-offset-2">
                                                    <h6 style="color: red;"><i class="icon icon-close"></i><a
                                                            style=" white-space: normal;">{{'NewCardPortal.warnImageFormat' | translate}}</a>
                                                    </h6>
                                                </div>
                                                <div style="width:100% " *ngIf="item.request_access_card===true"
                                                    class="col-md-12 col-xs-12 col-md-offset-0 col-xs-offset-0">
                                                    <h6><i class="icon icon-check"></i><a
                                                            style=" white-space: normal;">{{'NewCardPortal.meetRequirement' | translate}}
                                                    </a></h6>
                                                </div>
                                                <div *ngIf="item.request_access_card===false"
                                                    class="col-md-12 col-xs-12">
                                                    <h6><i class="icon icon-close"></i><a>{{'NewCardPortal.peopleActive' | translate}}
                                                    </a></h6>
                                                </div>
                                            </div>
                                            <hr style="padding: 0px;">
                                        </div>
                                    </div>
                                    <div class="o-etable__employee" style="background-color: #F2F0E9;">

                                        <div class="row"
                                            *ngIf="!this.formRadio.value.document || this.formRadio.value.document==='nationalId' ">
                                            <br>
                                            <div class="col-md-2 col-md-offset-1">
                                                <h5>
                                                    <div>{{'NewCardPortal.dataEntry' | translate}}</div>
                                                    <span>{{'NewCardPortal.dataEmployee' | translate}}</span>
                                                </h5>
                                            </div>
                                            <form class="o-form" [formGroup]="formRadio">
                                                <div class="col-md-2 col-md-offset-0">
                                                    <label style="cursor:pointer; padding-bottom: 5px;">
                                                        <input class="form-check-input" type="radio" formControlName="document" value="nationalId" id="nationalId" style="cursor:pointer"> {{'NewCardPortal.labelRUT' | translate}} <br>
                                                    </label><br>
                                                    <label style="cursor:pointer;">
                                                        <input class="form-check-input" type="radio" formControlName="document" value="passportNumber" id="passportNumber" style="cursor:pointer">
                                                        {{'NewCardPortal.labelPassport' | translate}}
                                                    </label>
                                                    <label>
                                                        <mat-error *ngIf="formRadio.controls['document'].hasError('required') && radioPress">
                                                            {{'NewCardPortal.documentType' | translate}}
                                                        </mat-error>
                                                    </label>
                                                </div>
                                                <div class="col-md-3 col-md-offset-2">
                                                    <div class="o-etable__addemployee">
                                                        <input style="background-color: white;" class="o-form__input"
                                                            formControlName="ID" type="text" placeholder="{{'NewCardPortal.placeholderRUT' | translate}}">
                                                        <mat-error
                                                            *ngIf="formRadio.controls['ID'].hasError('validateRUN')">
                                                            <i class="icon icon-close"></i>
                                                            {{'NewCardPortal.notValidRut' | translate}} {{'NewCardPortal.rutExample' | translate}}
                                                        </mat-error>
                                                    </div>
                                                    <mat-error *ngIf="formRadio.controls['ID'].hasError('required') && radioPress ">
                                                        {{'NewCardPortal.documentRequired' | translate}}
                                                    </mat-error>
                                                </div>
                                                <div class="col-md-2"><a (click)="add()" class="btn btn--primary"
                                                        id="clone-add_employee">{{'NewCardPortal.btnAdd' | translate}}</a>
                                                </div>
                                            </form>
                                        </div>
                                        <div class="row" *ngIf="this.formRadio.value.document==='passportNumber' "> <br>
                                            <div class="col-md-2 col-md-offset-1">
                                                <h5>
                                                    <div>{{'NewCardPortal.dataEntry' | translate}}</div>
                                                    <span>{{'NewCardPortal.dataEmployee' | translate}}</span>
                                                </h5>
                                            </div>
                                            <form class="o-form" [formGroup]="formRadio" (ngSubmit)="add()">
                                                <div class="col-md-2 col-md-offset-0">
                                                    <label style="cursor:pointer; padding-bottom: 5px;">
                                                        <input class="form-check-input" type="radio"
                                                            formControlName="document" value="nationalId"
                                                            id="nationalId" style="cursor:pointer"
                                                            (change)="formRadio.controls['countryId'].setValue('');">
                                                            {{'NewCardPortal.labelRUT' | translate}} <br>
                                                    </label><br>
                                                    <label style="cursor:pointer;">
                                                        <input class="form-check-input" type="radio"
                                                            formControlName="document" value="passportNumber"
                                                            id="passportNumber" style="cursor:pointer">
                                                        {{'NewCardPortal.labelPassport' | translate}}
                                                    </label>
                                                    <label>
                                                        <mat-error
                                                            *ngIf="formRadio.controls['document'].hasError('required') && radioPress">
                                                            {{'NewCardPortal.documentType' | translate}} </mat-error>
                                                    </label>

                                                </div>
                                                <div class="col-md-2">
                                                    <select name="country" class="o-form__select" required
                                                        style="cursor:pointer" formControlName="countryId" required
                                                        title="{{ 'NewCardPortal.selCountry' | translate}}">
                                                        <option [value]="''" disabled selected>
                                                            {{ 'NewCardPortal.selCountry' | translate}}</option>
                                                        <option [value]="country.name"
                                                            *ngFor="let country of selectCountry"> <span *ngIf="getlang()==='es'">{{country.nameEs}}</span> <span *ngIf="getlang()==='en'">{{country.name}}</span>
                                                        </option>
                                                    </select>
                                                </div>
                                                <div class="col-md-3 col-md-offset-0">
                                                    <div class="o-etable__addemployee">
                                                        <input style="background-color: white;" class="o-form__input"
                                                            formControlName="ID" type="text"
                                                            placeholder="{{'NewCardPortal.placeholderPassport' | translate}}">
                                                    </div>
                                                    <mat-error
                                                        *ngIf="formRadio.controls['ID'].hasError('required') && radioPress ">
                                                        {{'NewCardPortal.documentRequired' | translate}} </mat-error>
                                                </div>
                                                <div class="col-md-2"><a (click)="add()" class="btn btn--primary"
                                                        id="clone-add_employee">{{'NewCardPortal.btnAdd' | translate}}</a>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="" *ngIf="formRadio.value.options==='bulk'" id="responsebulk">
                    <div class="col-md-12 u-pt30">
                        <label
                            class="o-title o-title--small o-title--semi u-mb10">{{'NewCardPortal.dataEntry' | translate}}</label>
                        <label class="o-text o-text--description">{{'NewCardPortal.completeExcel' | translate}}</label>
                        <div class="custom-file">
                            <div class="custom-file-text">
                                <div class="custom-file-text-cont" type="file" *ngIf="fileName=='false'"
                                    name="fileUpload">
                                    <i class="icon icon-clip"> </i>
                                    <p>{{ 'NewCardPortal.attachDocument' | translate}}</p>
                                </div>
                                <div class="custom-file-text-cont" type="file" *ngIf="fileName !== 'false'">
                                    <i *ngIf="excelvalid" class="icon icon-check"></i>
                                    <p> {{ fileName }}</p>
                                </div>
                                <div *ngIf="!excelvalid" style="width:100%; background-color: #F2F0E9" align="center">
                                    <span>
                                        <h5 style="padding: 15px;">
                                            <mat-error style=" white-space: normal; ">
                                                <i class="icon icon-close"></i>
                                                {{ 'NewCardPortal.fileNotValid' | translate}}
                                            </mat-error>
                                        </h5>
                                    </span>
                                </div>
                                <div *ngIf="filesize" style="width:100%; background-color: #F2F0E9" align="center">
                                    <span>
                                        <h5 style="padding: 15px;">
                                            <mat-error style=" white-space: normal; "><i class="icon icon-close"></i>
                                                {{ 'NewCardPortal.sizeNotValid' | translate}}</mat-error>
                                        </h5>
                                    </span>
                                </div>
                                <div *ngIf="fileformat" style="width:100%; background-color: #F2F0E9" align="center">
                                    <span>
                                        <h5 style="padding: 15px;">
                                            <mat-error style=" white-space: normal; "><i class="icon icon-close"></i>
                                                {{ 'NewCardPortal.formatNotValid' | translate}}</mat-error>
                                        </h5>
                                    </span>
                                </div>
                                <span *ngIf="fileError" style="color: rgb(167, 4, 4);">(
                                    {{ 'NewCardPortal.validation3' | translate}} ) </span>
                            </div>
                            <div class="custom-file-input">
                                <input class="custom-file-input attach_document" id="customFile" type="file"
                                    data-msg="Volver a subir archivo"
                                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                    (change)="detectFiles($event)">
                                <span *ngIf="fileName !== 'false'">
                                    {{'NewCardPortal.uploadFileAgain' | translate}}</span>
                                <span *ngIf="fileName == 'false'"> {{'NewCardPortal.uploadFile' | translate}}</span>
                            </div>
                            <div class="custom-file_extend">
                                <a style="cursor: pointer;" download="BulkNewCard.xlsx" target="_blank"
                                    href="/assets/BulkNewCard.xlsx">

                                    <span>{{ 'NewCardPortal.template' | translate}}</span>
                                </a>
                                <i hidden class="icon icon-link"></i>
                            </div>
                            <div *ngIf="formTableEntry.length===0 && submited"
                                style="width:100%; background-color: #F2F0E9;" align="center">
                                <span>
                                    <h5 style="padding: 15px;">
                                        <mat-error style=" white-space: normal; "><i class="icon icon-close"></i>
                                            {{'NewCardPortal.warnFile' | translate}}</mat-error>
                                    </h5>
                                </span>
                            </div>
                        </div>
                        <div *ngIf="formTableEntry.length > 0" id="images">
                            <hr>
                            <label class="o-text o-text--description">
                                {{'NewCardPortal.attachWarn' | translate}}&nbsp;
                                <!-- <span class="ptooltip--static ptooltip" matTooltip="{{'NewCardPortal.photoTooltip' | translate}} "> ? </span> -->
                                <svg matTooltip="{{'NewCardPortal.photoTooltip' | translate}}"
                                    width="1em" height="1em" viewBox="0 0 16 16"
                                    class="bi bi-question-circle ptooltip--static ptooltip"
                                    fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd"
                                        d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                    <path
                                        d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z" />
                                </svg>&nbsp;<label style="color: coral;">*</label></label>
                            <div class="custom-file">
                                <div class="custom-file-text">
                                    <div class="custom-file-text-cont" type="file" *ngIf="imagesUploaded=='false'"
                                        name="fileUpload">
                                        <i class="icon icon-clip"> </i>
                                        <p>{{ 'NewCardPortal.attachImg' | translate}}</p>

                                    </div>
                                    <div class="custom-file-text-cont" type="file" *ngIf="imagesUploaded !== 'false'">
                                        <i class="icon icon-check"> </i>
                                        <p> {{'NewCardPortal.attachMore' | translate}}</p>
                                    </div>
                                    <div *ngIf="controlImagesFormat" style="width:100%; background-color: #F2F0E9"
                                        align="center; padding-top: 10px;">
                                        <span>
                                            <h5 style="padding: 15px;">
                                                <mat-error style=" white-space: normal; "><i
                                                        class="icon icon-close"></i>
                                                    {{'NewCardPortal.formatNotValid' | translate}}</mat-error>
                                            </h5>
                                        </span>
                                    </div>
                                    <div *ngIf="controlImagesSize" style="width:100%; background-color: #F2F0E9"
                                        align="center; padding-top: 10px;">
                                        <span>
                                            <h5 style="padding: 15px;">
                                                <mat-error style=" white-space: normal; "><i
                                                        class="icon icon-close"></i>
                                                    {{'NewCardPortal.sizeNotValid' | translate}}</mat-error>
                                            </h5>
                                        </span>
                                    </div>
                                </div>
                                <div class="custom-file-input">
                                    <input class="custom-file-input attach_document" id="customFile" multiple
                                        type="file" data-msg="Volver a subir archivo" accept="image/jpeg, .jpg"
                                        (change)="uploadPhotos($event)">
                                    <span *ngIf="imagesUploaded !== 'false'" style="font-size: 11px;">
                                        {{'NewCardPortal.uploadImgAgain' | translate}}</span>
                                    <span *ngIf="imagesUploaded == 'false'" style="font-size: 11px;">
                                        {{'NewCardPortal.uploadImg' | translate}}</span>
                                </div>
                            </div>
                            <div *ngIf="imagesNotmatch" style="width:100%; background-color: #F2F0E9"
                                align="center; padding-top: 20px">
                                <span>
                                    <h5 style="padding: 15px;">
                                        <mat-error style=" white-space: normal; "><i class="icon icon-close"></i>
                                            {{'NewCardPortal.warnImageNumber' | translate}}</mat-error>
                                    </h5>
                                </span>
                            </div>

                        </div>
                    </div>

                    <div class="col-md-12 u-pt30  js-step-file">
                        <div class="o-etable">
                            <div class="o-etable__employee">
                                <div class="row">
                                    <div class="col-md-1 col-xs-2">
                                        <p> <strong>{{'NewCardPortal.colNumber' | translate}}</strong></p>
                                    </div>
                                    <div class="col-md-1 col-xs-2">
                                        <p class="u-hide__desktop">
                                            <strong>{{'NewCardPortal.colType' | translate}}</strong></p>
                                    </div>
                                    <div class="col-md-2 col-xs-10  col-md-offset-0 col-xs-offset-0">
                                        <p class="u-show__mobile">
                                            <strong>{{'NewCardPortal.colDetails' | translate}} </strong></p>
                                        <p class="u-hide__desktop">
                                            <strong>{{'NewCardPortal.colRutpass' | translate}}</strong></p>
                                    </div>
                                    <div class="col-md-2 col-xs-10 col-md-offset-0 col-xs-offset-2">
                                        <p class="u-hide__desktop">
                                            <strong>{{'NewCardPortal.colName' | translate}}</strong></p>
                                    </div>
                                    <div class="col-md-3 col-xs-10 col-md-offset-0 col-xs-offset-2">
                                        <p class="u-hide__desktop">
                                            <strong>{{'NewCardPortal.colEmail' | translate}}</strong></p>
                                    </div>
                                    <div class="col-md-2 col-xs-10 col-md-offset-0 col-xs-offset-2">
                                        <div class=" u-hide__desktop">
                                        <p> <strong>{{'NewCardPortal.colPhoto' | translate}}</strong></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="formTableEntry && disabledItems && notValid">
                                <div *ngIf="formTableEntry.length==0 && disabledItems.length==0 && notValid.length==0"
                                    class="o-etable__employee o-etable__employee--empty">
                                    <div class="row">
                                        <div class="col-md-6 col-md-offset-1">
                                            <p>{{'NewCardPortal.warnDataEntry' | translate}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="o-etable--body">
                                <div *ngIf="formTableEntry.length>0" class="o-etable__group">
                                    <div class="o-etable__employee">
                                        <div class="row">
                                            <div class="col-md-12 col-xs-12">
                                                <h6> <i
                                                        class="icon icon-check"></i><a
                                                        style=" white-space: normal;">{{'NewCardPortal.meetRequirement' | translate}}
                                                </a>
                                                </h6>
                                            </div>
                                        </div>
                                    </div>
                                    <div *ngFor="let item of formTableEntry; let i = index"
                                        class="o-etable__employee o-etable__employee--approved">
                                        <a class="remove-employee" (click)="deletePeople(i)"></a>
                                        <div class="row">
                                            <div class="col-md-1 col-xs-2">
                                                <p> <span>{{i+1}}</span></p>
                                            </div>
                                            <div class="col-md-1 col-xs-2">
                                                 <p *ngIf="item.passportNumber">{{'NewCardPortal.labelPassport' | translate}}</p>
                                                        <p *ngIf="item.passportNumber && item.nationalId"> / </p>
                                                        <p *ngIf="item.nationalId">{{'NewCardPortal.labelRUT' | translate}}</p>

                                            </div>
                                            <div class="col-md-2 col-xs-10 col-md-offset-0 col-xs-offset-2">
                                                <p><span *ngIf="item.passportNumber">{{item.passportNumber}}</span><span
                                                        *ngIf="item.passportNumber && item.nationalId"> / </span> <span
                                                        *ngIf="item.nationalId">{{item.nationalId}}</span></p>
                                            </div>
                                            <div class="col-md-2 col-xs-10 col-md-offset-0 col-xs-offset-2">
                                                <p>{{item.firstName + ' ' +item.lastName}}</p>
                                            </div>
                                            <div class="col-md-3 col-xs-10 col-md-offset-0 col-xs-offset-2">
                                                <p *ngIf="item.employeeType.trim()=='Employee'"
                                                    style=" white-space: normal;">{{item.email}}</p>
                                                <p *ngIf="item.employeeType.trim()=='Contractor'"
                                                    style=" white-space: normal;">{{item.companyEmail}}</p>
                                            </div>
                                            <div class="col-md-2 col-xs-10 col-md-offset-0 col-xs-offset-2">

                                                <p class="u-show__mobile" *ngIf="item.ImageFile">{{'NewCardPortal.colPhoto' | translate}}: <i class="icon icon-check"></i></p>
                                                <p class="u-hide__desktop" *ngIf="item.ImageFile"><i class="icon icon-check"></i></p>
                                                <p class="u-show__mobile" *ngIf="!item.ImageFile">{{'NewCardPortal.colPhoto' | translate}}: <i class="icon icon-more"></i></p>
                                                <p class="u-hide__desktop" *ngIf="!item.ImageFile"><i class="icon icon-more"></i></p>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="disabledItems">
                                    <div class="o-etable__group" *ngIf="disabledItems.length>0">
                                        <div class="o-etable__employee">
                                            <div class="row">
                                                <div class="col-md-12 col-xs-12">
                                                    <h6> <i class="icon icon-close"></i><span>
                                                            {{'NewCardPortal.peopleActive' | translate}}
                                                        </span><span>{{'NewCardPortal.siteReject' | translate}}</span>
                                                    </h6>
                                                </div>
                                            </div>
                                        </div>
                                        <div *ngFor="let itemdis of disabledItems; let i = index"
                                            class="o-etable__employee o-etable__employee--rejected">
                                            <a class="remove-employee" (click)="deletePeopleDisabled(i)"></a>
                                            <div class="row">
                                                <div class="col-md-1 col-xs-2">
                                                    <p> <span>{{i+1}}</span></p>
                                                </div>
                                                <div class="col-md-1 col-xs-10">
                                                    <p> <span
                                                            *ngIf="itemdis.passportNumber">{{'NewCardPortal.labelPassport' | translate}}</span><span
                                                            *ngIf="itemdis.passportNumber && itemdis.nationalId"> /
                                                        </span> <span *ngIf="itemdis.nationalId">{{'NewCardPortal.labelRUT' | translate}}</span></p>
                                                </div>
                                                <div class="col-md-2 col-xs-10">
                                                    <p> <span
                                                            *ngIf="itemdis.passportNumber">{{itemdis.passportNumber}}</span><span
                                                            *ngIf="itemdis.passportNumber && itemdis.nationalId"> /
                                                        </span> <span
                                                            *ngIf="itemdis.nationalId">{{itemdis.nationalId}}</span></p>
                                                </div>
                                                <div class="col-md-2 col-xs-10 col-md-offset-0 col-xs-offset-2">
                                                    <p>{{itemdis.firstName + ' ' +itemdis.lastName}}</p>
                                                </div>
                                                <div class="col-md-3 col-xs-10 col-md-offset-0 col-xs-offset-2">

                                                    <p *ngIf="itemdis.employeeType.trim()=='Employee'"
                                                        style=" white-space: normal;">{{itemdis.email}}</p>
                                                    <p *ngIf="itemdis.employeeType.trim()=='Contractor'"
                                                        style=" white-space: normal;">{{itemdis.companyEmail}}</p>
                                                </div>
                                                <div class="col-md-1 col-xs-2">
                                                    <p> <span> - </span></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="notValid">
                                    <div class="o-etable__group" *ngIf="notValid.length>0">
                                        <div class="o-etable__employee">
                                            <div class="row">
                                                <div class="col-md-12 col-xs-12">
                                                    <h6> <i class="icon icon-close"></i><span>{{'NewCardPortal.rutpassWarn' | translate}}
                                                        </span></h6>
                                                </div>
                                            </div>
                                        </div>
                                        <div *ngFor="let itemNV of notValid; let i = index"
                                            class="o-etable__employee o-etable__employee--rejected">
                                            <a class="remove-employee" (click)="deletePeopleNotfound(i)"></a>
                                            <div class="row">
                                                <div class="col-md-1 col-xs-2">
                                                    <p> <span>{{i+1}}</span></p>
                                                </div>
                                                <div class="col-md-1 col-xs-2">
                                                    <p> <span> - </span></p>
                                                </div>
                                                <div class="col-md-2 col-xs-10">
                                                    <p><span>{{itemNV.documentNumber}}</span></p>
                                                </div>
                                                <div class="col-md-2 col-xs-10 col-md-offset-0 col-xs-offset-2">
                                                    <p> - </p>
                                                </div>
                                                <div class="col-md-3 col-xs-10 col-md-offset-0 col-xs-offset-2">
                                                    <p> - </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="o-form__tabresponse" id="responsebulk">
                    <div class="col-md-12 u-pt30">
                        <label
                            class="o-title o-title--small o-title--semi u-mb10">{{'NewCardPortal.dataEntry' | translate}}</label>
                        <label
                            class="o-text o-text--description ">{{'NewCardPortal.rutpassWarn' | translate}}</label>

                        <div class="custom-file">
                            <div class="custom-file-text">
                                <div class="custom-file-text-cont"><i class="icon icon-clip"></i>
                                    <p>{{'NewCardPortal.attachInfoDocument' | translate}}</p>
                                </div>
                            </div>
                            <div class="custom-file-input">
                                <input class="custom-file-input attach_document" type="file"
                                    data-msg="Volver a subir archivo">
                            </div>

                            <div class="custom-file_extend">
                                <a><span>{{'NewCardPortal.template' | translate}}</span><i
                                        hiddenclass="icon icon-link"></i></a></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="o-etable__group" style="padding-top: 10px;">
                <div *ngIf="controlRepeatPerson" style="width:100%; background-color: #F2F0E9" align="center">
                    <span>
                        <h5 style="padding: 15px;">
                            <mat-error style=" white-space: normal; "><i class="icon icon-close"></i>
                                {{'NewCardPortal.personEntered' | translate}}</mat-error>
                        </h5>
                    </span>
                </div>
                <div *ngIf="controlNotFoundError" style="width:100%; background-color: #F2F0E9" align="center">
                    <span>
                        <h5 style="padding: 15px;">
                            <mat-error style=" white-space: normal; "><i class="icon icon-close"></i>
                                {{'NewCardPortal.personNotFound' | translate}}</mat-error>
                        </h5>
                    </span>
                </div>
                <div *ngIf="controlMissImage" style="width:100%; background-color: #F2F0E9" align="center">
                    <span>
                        <h5 style="padding: 15px;">
                            <mat-error style=" white-space: normal; "><i class="icon icon-close"></i>
                                {{'NewCardPortal.attachAllPeople' | translate}}</mat-error>
                        </h5>
                    </span>
                </div>
                <div *ngIf="controlCountryError && formRadio.controls['countryId'].hasError('required') "
                    style="width:100%; background-color: #F2F0E9" align="center">
                    <span>
                        <h5 style="padding: 15px;">
                            <mat-error style=" white-space: normal; "><i class="icon icon-close"></i>
                                {{'NewCardPortal.notCountry' | translate}}</mat-error>
                        </h5>
                    </span>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 u-pt50">
                    <div class="o-form__checkbox u-mb20">
                        <input type="checkbox" value="value" formControlName="Confirm" name="Confirm"
                            required><span></span><a class="open_modal" (click)="openDialogConfirm()" data="terms"
                            style="cursor:pointer">{{'NewCardPortal.confirm' | translate}}</a>

                    </div>

                    <div *ngIf="formNewcard.controls['Confirm'].hasError('required') && submited"
                        style="width:100%; background-color: #F2F0E9" align="center">
                        <span>
                            <h5 style="padding: 15px;">
                                <mat-error style=" white-space: normal; "><i class="icon icon-close"></i>
                                    {{ 'NewCardPortal.confirmTerms' | translate}} </mat-error>
                            </h5>
                        </span>
                    </div>
                </div>
                <div class="col-md-12 u-pt50">
                    <a class="btn" [routerLink]="['/']">{{ 'NewCardPortal.btnCancel' | translate}}</a>
                    <button *ngIf="buttonEnable" class="btn btn--primary"
                        (click)="onSubmit()">{{ 'NewCardPortal.btnGenerate' | translate}}</button>
                </div>
            </div>
        </form>
    </div>
</div>
